import React, { Component } from 'react';
import { Utils } from 'services/utils';
import DetailView from './Components/DetailView';
import ListView from './Components/ListView';

class ReleaseNotes extends Component {
	constructor(props) {
		super(props);
		this.state = {
			year: 'latest',
			scrollTop: 0,
			scrollPositionArrows: 0,
			page: 'LIST_VIEW',
			params: null,
			releaseNotes: null,
			currentYear: 'latest',
		};
	}

	setActiveYear = year => {
		const currentActiveYear = document.querySelector('.year.active');
		const newActiveYear = document.getElementById(year);
		if (currentActiveYear) {
			currentActiveYear.classList.remove('active');
		}
		if (newActiveYear) {
			newActiveYear.classList.add('active');
		}
		this.setState({ year, currentYear: year });
	};

	onScroll = scrollTopNew => {
		const { scrollTop } = this.state;

		if (scrollTop !== scrollTopNew) {
			this.updateScrollArrows(scrollTopNew);
			this.setState({ scrollTop: scrollTopNew });
		}
	};
	updateScrollArrows = scrollTopBar => {
		this.setState({ scrollPositionArrows: scrollTopBar / 30 });
	};
	updateScrollBar = scrollPosition => {
		this.setState({ scrollTop: 30 * scrollPosition });
	};
	createReleaseFilter = () => {
		const headers = ['older', 'latest'];
		const { currentYear } = this.state;
		return headers.map(header => {
			return (
				<div
					className={header === currentYear ? `year active` : `year`}
					id={header}
					onClick={() => this.setActiveYear(header)}
					key={header}
				>
					{header}
				</div>
			);
		});
	};

	updatePage = (page, params) => {
		const { refreshReleaseNotes } = this.props;
		refreshReleaseNotes();
		this.setState({ page, params });
	};

	render() {
		const { scrollTop, scrollPositionArrows, page, year, params } = this.state;
		const {
			site,
			releases,
			unviewedEulaNotifications,
			unviewedPolicyNotifications,
			unviewedReleases,
			breakpoint,
			auth_status,
		} = this.props;

		return (
			<div className={`release-notes-container`}>
				<div className='header'>
					<div className='text footer70'>Release Notes</div>
					{unviewedReleases && (
						<div className='notifications'>
							{Utils.getNotificationIcon(
								site.module,
								unviewedReleases > 9 ? '!' : unviewedReleases,
								breakpoint,
							)}
						</div>
					)}
					{page === 'LIST_VIEW' ? (
						<div className='year-filter-wrapper'>
							{releases && this.createReleaseFilter(releases)}
						</div>
					) : (
						<div className='view-all footer31' onClick={() => this.updatePage('LIST_VIEW', null)}>
							VIEW ALL RELEASES
						</div>
					)}
				</div>
				<div className={`content ${site?.module}`}>
					{page === 'DETAIL_VIEW' && (
						<DetailView
							scrollTop={scrollTop}
							updateScrollBar={this.updateScrollBar}
							scrollPositionArrows={scrollPositionArrows}
							onScrollStop={this.onScroll}
							params={params}
							site={site}
						/>
					)}

					{page === 'LIST_VIEW' && releases && (
						<ListView
							updatePage={this.updatePage}
							scrollTop={scrollTop}
							updateScrollBar={this.updateScrollBar}
							scrollPositionArrows={scrollPositionArrows}
							onScrollStop={this.onScroll}
							releases={releases}
							year={year}
							site={site}
							auth_status={auth_status}
						/>
					)}
				</div>
				<div className='footer-section '>
					<div className='release-notes-section'>
						<div className='text footer50'>Release Notes</div>
						{unviewedReleases && (
							<div className='notifications'>
								{Utils.getNotificationIcon(
									site.module,
									unviewedReleases > 9 ? '!' : unviewedReleases,
									breakpoint,
								)}
							</div>
						)}
					</div>
					<div className='eula-section'>
						<div className='text footer50'>Eula</div>
						{unviewedEulaNotifications && (
							<div className='notifications'>
								{Utils.getNotificationIcon(site.module, unviewedEulaNotifications, breakpoint)}
							</div>
						)}
					</div>
					<div className='terms-section'>
						<div className='text footer50'>Terms/Policies</div>
						{unviewedPolicyNotifications && (
							<div className='notifications'>
								{Utils.getNotificationIcon(site.module, unviewedPolicyNotifications, breakpoint)}
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}
}
export default ReleaseNotes;
